// extracted by mini-css-extract-plugin
module.exports = {"image":"CTA-newsletter-styles-module--image--72wKJ","cta":"CTA-newsletter-styles-module--cta--3TMly","button":"CTA-newsletter-styles-module--button--17RdW"};